module.exports = __webpack_public_path__ + "static/media/bspu.96dc03ae.png";